import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import Panel from "Portal/NewPortal/Shared/Panel";

import { Div } from "components/Base";

import {
  getFiles,
  getSectionHeaderColor,
  getSectionHeaderFont,
  getSectionHeaderSize,
  getSectionIconById
} from "Portal/NewPortal/PortalHome/selectors";

// import { noop } from "utils/General";

// import { actions } from "Portal/NewPortal/PortalHome/model";

// import { SECTIONS_IDS } from "Portal/NewPortal/PortalHome/constants";

import File from "./File";

import { showModal } from "redux/modules/modal/actions";

const decorate = R.compose(
  connect(
    state => ({
      files: getFiles(state),
      sectionHeaderColor: getSectionHeaderColor(state),
      sectionHeaderFont: getSectionHeaderFont(state),
      sectionHeaderSize: getSectionHeaderSize(state)
    }),
    {
      // onClickPanelHeader: actions.setSelectedCategory,
      showModal
    }
  )
);

const Files = ({ files = [], showModal }) => {
  if (!files.length) {
    return null;
  }

  const icon = getSectionIconById("files") || null;

  return (
    <Panel
      title={"Files"}
      panelContainerStyle={{
        maxHeight: "400px",
        height: "auto",
        overflow: "auto"
      }}
      icon={icon}
      // onClickHeader={() => {

      //onClickPanelHeader({ category: SECTIONS_IDS.FILES })}
      // }}
    >
      <Div display="column.flex-start.center" style={{ gap: "12px" }}>
        {R.map(
          file => (
            <File key={file.id} data={file} showModal={showModal} />
          ),
          files
        )}
      </Div>
    </Panel>
  );
};

export default decorate(Files);
